var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0z",
    transform: "translate(-122 -508) translate(110 236) translate(0 233) translate(0 26) translate(12 13)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2447",
    fillRule: "nonzero",
    stroke: "#1E2447",
    strokeWidth: 0.3,
    d: "M15.595 7.87h-1.303V4.981C14.292 2.676 12.456.8 10.2.8 7.944.8 6.108 2.676 6.108 4.982v2.887H4.805c-.885 0-1.605.736-1.605 1.64v8.072c0 .904.72 1.64 1.605 1.64h10.79c.885 0 1.605-.736 1.605-1.64V9.51c0-.905-.72-1.64-1.605-1.64zM6.913 4.981c0-1.853 1.475-3.36 3.287-3.36 1.813 0 3.287 1.507 3.287 3.36v2.887H6.913V4.982zm9.482 12.599c0 .45-.359.817-.8.817H4.805c-.44 0-.8-.366-.8-.817V9.51c0-.451.359-.818.8-.818h10.79c.44 0 .8.366.8.818v8.07h0z",
    transform: "translate(-122 -508) translate(110 236) translate(0 233) translate(0 26) translate(12 13)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLock);
export default __webpack_public_path__ + "static/media/login-lock.6f8f7ca9.svg";
export { ForwardRef as ReactComponent };